import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useBilling } from "../context/BillingContext";

export const BillingGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLocked, loading } = useBilling();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    if (isLocked) {
      // If locked, prevent access to anything except the lockout page
      if (location.pathname !== "/billing/lockout") {
        navigate("/billing/lockout", { replace: true });
      }
    } else {
      // If unlocked, prevent staying on the lockout page
      if (location.pathname === "/billing/lockout") {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [isLocked, loading, location.pathname, navigate]);

  // If locked and not on lockout page yet, render nothing (wait for redirect)
  if (isLocked && location.pathname !== "/billing/lockout") {
    return null;
  }

  return <>{children}</>;
};
